const events = ['fileProgress', 'fileSuccess', 'fileComplete', 'fileError']

export default events



// WEBPACK FOOTER //
// ./src/common/file-events.js